import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";

export interface AuthState {
  isWalletExist: boolean;
  isAuthorized: boolean;
}

const initialState: AuthState = {
  isWalletExist: false,
  isAuthorized: false,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setWalletExist: (state, action: PayloadAction<boolean>) => {
      state.isWalletExist = action.payload;
    },
    setAuthorized: (state, action: PayloadAction<boolean>) => {
      state.isAuthorized = action.payload;
    }
  }
});

export const authActions = authSlice.actions;
export const authReducer = authSlice.reducer;